import type { IGetClientInfoDTO } from "@modules/orders/dtos/IGetClientInfoDTO";
import type { Customer, FreightType } from "../../model/customer.model";

const str = (v?: string) => (v ?? "").trim();
const bool = (v?: boolean) => Boolean(v);
const num = (v?: number, fallback = 0) =>
  typeof v === "number" ? v : fallback;

export function toCustomerMapper(raw: IGetClientInfoDTO): Customer {
  return {
    cnpj: str(raw.CNPJ),
    id: str(raw.id),
    name: str(raw.name),

    hiddePrice: bool(raw.hiddePrice),

    freightType: str(raw.freightType) as FreightType,
    payCond: num(raw.payCond),
    companyID: str(raw.companyID),

    distributionChannel: str(raw.DistributionChannel),
    division: str(raw.Division),

    accessor: {
      id: str(raw.accessor?.id),
      name: str(raw.accessor?.name),
    },

    addresses: (raw.address ?? []).map((a) => ({
      id: str(a.id),
      street: str(a.street),
      district: str(a.district),
      city: str(a.city),
      uf: str(a.UF),
      postalCode: str(a.postalCode),
      phone: str(a.phone),
      email: str(a.email),
      transportationZone: str(a.transportationZone),
      filialIdDefault: str(a.filialIdDefault),
    })),

    withdrawBasis: (raw.withdrawBasis ?? []).map((w) => ({
      withdrawBasis: str(w.withdrawBasis),
      name: str(w.name),
      branch: str(w.branch),
      branchName: str(w.branchName),
      filialID: str(w.filialID),
      shippingPoint: str(w.shippingPoint),
      timeZone: str(w.timeZone),
    })),

    products: (raw.products ?? []).map((p) => ({
      id: str(p.id),
      description: str(p.description),
      payCond: num(p.payCond),
    })),
  };
}
